import React from "react";
import classNames from "classnames";
import styled from "styled-components";

const StyledLabel = styled.div`
  color: black;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 20px 0 0 -50%;
  width: 100%;
  text-align: center;
`;

export default function Spinner(props) {
    const {
        classes = {},
        label,
        style,
        labelStyle,
        small = false,
        color = "#50bbe6"
    } = props;
    return (
        <div
            className={classNames(classes.spinnerAddOn, "spinner")}
            style={style}
        >
            {small &&
            <svg className="circular" style={{ width: "20px", height: "20px" }}>
                <circle className="path" cx="10" cy="10" r="7.5" style={{ stroke: color, strokeWidth: 2 }} />
            </svg>
            }
            {!small &&
                <svg className="circular">
                    <circle className="path" cx="20" cy="20" r="15" style={{ stroke: color }} />
                </svg>
            }
            {
                label &&
                <StyledLabel
                    style={labelStyle}
                >{label}</StyledLabel>
            }
        </div>
    );
}
